module.exports = __webpack_public_path__ + "img/strip-19.8f0a3773.jpg";